import React, { useState } from 'react';

import { useDependencies } from '../../misc/DependenciesProvider.tsx';
import { useSnackbarMessage } from '../SnackMessge.tsx';
import { Button, TextField } from '@mui/material';

interface ProfilePageProps {
    // Define any props if needed, otherwise it's an empty interface
}

export function ProfilePage({ }: ProfilePageProps) {
    const { fracAPI } = useDependencies();
    const { showMessage } = useSnackbarMessage();
    const [oldPassword, setOldPassword] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [newPasswordConfirm, setNewPasswordConfirm] = useState<string>("");

    const PASSWORD_MIN_LENGTH = 8;
    const PASSWORD_MAX_LENGTH = 20;

    const getPasswordValidationErrors = (): string[] => {
        const errors: string[] = [];
        if (newPassword.length < PASSWORD_MIN_LENGTH || newPassword.length > PASSWORD_MAX_LENGTH) {
            errors.push(`The password must be ${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters`);
        }
        if (!/[a-z]/.test(newPassword)) {
            errors.push("The password must contain at least 1 lowercase character");
        }
        if (!/[A-Z]/.test(newPassword)) {
            errors.push("The password must contain at least 1 uppercase character");
        }
        if (!/\d/.test(newPassword)) {
            errors.push("The password must contain at least 1 digit character");
        }
        if (!/[^a-zA-Z0-9]/.test(newPassword)) {
            errors.push("The password must contain at least 1 special character");
        }
        return errors;
    }

    const passwordValidationErrors = getPasswordValidationErrors();
    const isPasswordValid: boolean = passwordValidationErrors.length === 0;

    const performUpdate = async () => {
        if (isPasswordValid) {
            const error: string | null = await fracAPI.changePassword(oldPassword, newPassword);
            if (error != null) {
                showMessage(error);
            } else {
                showMessage("User updated successfully");
            }
        }
    }

    return (
        <div>
            <div>
                Old Password:
            </div>
            <TextField
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
            />

            <div>
                New Password:
            </div>
            <TextField
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
            />
            {!isPasswordValid && (
                <ul>
                    {passwordValidationErrors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            )}

            <div>
                New Password Confirm:
            </div>
            <TextField
                type="password"
                value={newPasswordConfirm}
                onChange={(e) => setNewPasswordConfirm(e.target.value)}
            />

            <Button
                disabled={!isPasswordValid || newPassword !== newPasswordConfirm}
                onClick={() => { performUpdate() }}
            >
                Update
            </Button>
        </div>
    );
}